enum ProjectionProviderByEnum {
  NPI = "npi",
  TIN = "tin",
  NPIAndTIN = "npiAndTin",
  Name = "name",
}

export default ProjectionProviderByEnum;